import Reveal from "@/components/Reveal";

// Inner page hero band (About, Services, Contact).
const PageHeader = ({ overline, title, subtitle }) => {
  return (
    <section className="bg-[#F5F6FB] border-b border-[#2A2E7A]/8" data-testid="page-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24">
        <Reveal>
          {overline && (
            <p className="text-[13px] font-semibold uppercase tracking-[0.18em] text-[#4B5CAB]">
              {overline}
            </p>
          )}
          <h1 className="mt-4 font-heading text-4xl sm:text-5xl font-bold tracking-[-0.02em] text-[#2A2E7A] leading-[1.12] max-w-3xl">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-lg text-[#51607A] leading-relaxed max-w-2xl">
              {subtitle}
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
};

export default PageHeader;
